export type AppConfig = {
  NODE_ENV: string;
  PCA_AUTHORITY: string;
  PCA_CLIENT_ID: string;
  PCA_LOGOUT_REDIRECT_URI: string;
  PCA_REDIRECT_URI: string;
  BASE_URL: string;
  LEARNING_BASE_URL: string;
  LCMS_BASE_URL: string;
  TENANT_BASE_URL: string;
  UNLEASH_URL: string;
  UNLEASH_CLIENT_KEY: string;
  UNLEASH_CLIENT_NAME: string;
  TAG_NAME: string;
  AZURE_BYPASS_ENABLED: string;
  AUTH0_DOMAIN: string;
  AUTH0_CONNECTION: string;
  AUTH0_CLIENT_ID: string;
  AUTH0_READ_SCOPE: string;
  AUTH0_SCOPE: string;
};

const config: AppConfig = Object.assign(
  {
    NODE_ENV: "development",
    PCA_AUTHORITY: "",
    PCA_CLIENT_ID: "",
    PCA_LOGOUT_REDIRECT_URI: "",
    PCA_REDIRECT_URI: "",
    BASE_URL: window.location.origin.replace(/\/$/, ""),
    LEARNING_BASE_URL: "https://localhost:7261",
    LCMS_BASE_URL: "https://ccau-lcms-integration.review.ccaeducate.me/ct",
    TENANT_BASE_URL: "https://ccau-lcms-integration.review.ccaeducate.me/tm",
    UNLEASH_URL: "",
    UNLEASH_CLIENT_KEY: "",
    UNLEASH_CLIENT_NAME: "",
    TAG_NAME: "",
    AZURE_BYPASS_ENABLED: "false",
    AUTH0_CONNECTION: "CCAU-TestDirectory",
    AUTH0_DOMAIN: "apollotest.us.auth0.com",
    AUTH0_CLIENT_ID: "vgYqqRiznDgdJsCrbDrHRuHgo9HiIBnt",
    AUTH0_READ_SCOPE: "read:current_user",
    AUTH0_SCOPE: "profile read:current_user update:current_user_metadata",
  },
  window.__APP_CONFIG__,
);

export default config;
